import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3303ROLES } from '../../U3303';
import type { U3303HolidayYearFormRow } from '../../U3303Service';

interface U3303HolidayYearFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<U3303HolidayYearFormRow> & {
    getData: () => U3303HolidayYearFormRow | null;
    getFormState: () => U2000FormStateEnumState;
    addNewHolidayYear: () => void;
    modifyHolidayYear: () => void;
    deleteHolidayYear: () => void;
  };
}

export const U3303HolidayYearFormToolBar: React.FC<U3303HolidayYearFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3303ROLES.ADD),
      handleClick: () => formStateHandlers.addNewHolidayYear(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3303ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyHolidayYear(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3303ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteHolidayYear(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
